import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var GrantDiscordAccessInputClass;
function GrantDiscordAccessInput() {
  if (GrantDiscordAccessInputClass === VOID) {
    class $ {
      constructor(state, verifier, code, partyId, guildId) {
        this.c6u_1 = state;
        this.d6u_1 = verifier;
        this.e6u_1 = code;
        this.f6u_1 = partyId;
        this.g6u_1 = guildId;
      }
      toString() {
        return 'GrantDiscordAccessInput(state=' + this.c6u_1 + ', verifier=' + this.d6u_1 + ', code=' + this.e6u_1 + ', partyId=' + this.f6u_1.toString() + ', guildId=' + this.g6u_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.c6u_1);
        result = imul(result, 31) + getStringHashCode(this.d6u_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.e6u_1) | 0;
        result = imul(result, 31) + this.f6u_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.g6u_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GrantDiscordAccessInput()))
          return false;
        if (!(this.c6u_1 === other.c6u_1))
          return false;
        if (!(this.d6u_1 === other.d6u_1))
          return false;
        if (!(this.e6u_1 === other.e6u_1))
          return false;
        if (!this.f6u_1.equals(other.f6u_1))
          return false;
        if (!(this.g6u_1 === other.g6u_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'GrantDiscordAccessInput');
    GrantDiscordAccessInputClass = $;
  }
  return GrantDiscordAccessInputClass;
}
//region block: exports
export {
  GrantDiscordAccessInput as GrantDiscordAccessInputqu7hxtlblgwv,
};
//endregion

//# sourceMappingURL=GrantDiscordAccessInput.mjs.map
